import { PaginationItem } from '../models/pagination-item';

export function calculateVisiblePaginationItems(
  currentPage: number,
  numberOfPages: number,
): PaginationItem[] {
  const visibleItems = 7;

  if (numberOfPages <= visibleItems) {
    return Array.from({ length: numberOfPages }, (_, index) => {
      return {
        type: 'page',
        value: index + 1,
      };
    });
  }

  if (currentPage <= 3) {
    return [
      ...Array.from({ length: 5 }, (_, index) => {
        return {
          type: 'page' as const,
          value: index + 1,
        };
      }),
      {
        type: 'ellipsis',
      },
      {
        type: 'page',
        value: numberOfPages,
      },
    ];
  } else if (currentPage >= numberOfPages - 2) {
    return [
      {
        type: 'page',
        value: 1,
      },
      {
        type: 'ellipsis',
      },
      ...Array.from({ length: 5 }, (_, index) => {
        return {
          type: 'page' as const,
          value: numberOfPages + (-4 + index),
        };
      }),
    ];
  }

  return [
    {
      type: 'page',
      value: 1,
    },
    {
      type: 'ellipsis',
    },
    {
      type: 'page',
      value: currentPage - 1,
    },
    {
      type: 'page',
      value: currentPage,
    },
    {
      type: 'page',
      value: currentPage + 1,
    },
    {
      type: 'ellipsis',
    },
    {
      type: 'page',
      value: numberOfPages,
    },
  ];
}
